<template>
    <div class="flex-1" :class="index > 0 ? 'border-t border-gray-400 pt-8 mt-8' : 'mt-3'">
        <input
            type="hidden"
            :name="'showings[' + index + '][id]'"
            :value="showing.id"
        />

        <div class="flex flex-col flex-1 sm:flex-row sm:space-x-4 mb-3 -mt-4">
            <input-text
                class="flex-1"
                label="Name"
                :name="'showings[' + index + '][name]'"
                v-model="showing.name"
                placeholder="Name"
                :read_only="read_only"
            />

            <input-text
                class="flex-1"
                label="Agent"
                :name="'showings[' + index + '][agent]'"
                v-model="showing.agent"
                placeholder="Agent"
                :read_only="read_only"
            />

            <input-date
                class="flex-1"
                label="Date"
                :name="'showings[' + index + '][date]'"
                v-model="showing.date"
                :read_only="read_only"
            />
        </div>

        <div class="flex flex-col flex-1 sm:flex-row sm:space-x-4 mb-3">
            <input-text
                class="flex-1"
                label="Email"
                :name="'showings[' + index + '][email]'"
                v-model="showing.email"
                placeholder="Email"
                :read_only="read_only"
            />

            <input-text
                class="flex-1"
                label="Phone"
                :name="'showings[' + index + '][phone]'"
                v-model="showing.phone"
                placeholder="Phone"
                :read_only="read_only"
            />
        </div>

        <div class="flex flex-col flex-1 sm:flex-row sm:space-x-4 mb-3">
            <input-textarea
                class="flex-1"
                label="Notes"
                :name="'showings[' + index + '][notes]'"
                v-model="showing.notes"
                placeholder="Notes"
                :read_only="read_only"
                :rows="2"
            />
        </div>

        <div
            v-if="! read_only"
            class="cursor-pointer flex hover:text-red-600 items-center justify-end pt-4 text-gray-400"
            @click="deleteShowing"
        >
            <i class="fas fa-minus-circle"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showing: { default: () => ({}) },
        read_only: { default: false },
        index: { default: 0 },
        count: { default: 0 },
    },

    methods: {
        deleteShowing() {
            this.$emit('delete', this.showing.id);
        },
    },
}
</script>
